export enum SocketIOEventEnum {
  // Base events
  CONNECTION = 'connection',
  DISCONNECT = 'disconnect',
  CONNECT = 'connect',
  // Comment events
  COMMENT_ADD = 'comment:add',
  COMMENT_DELETE = 'comment:delete',
  COMMENT_RESTORE = 'comment:restore',
  COMMENT_EDIT = 'comment:edit',
  COMMENT_LIST = 'comment:list',
  COMMENT_SEARCH = 'comment:search',
  COMMENT_STATUS = 'comment:status',
  COMMENT_TOGGLE_FAVORITE = 'comment:toggle-favorite',
  // Thread events
  THREAD_USERS_MENTION_LIST = 'thread:users-mention-list',
  THREAD_USERS_MENTION_LIST_UPDATED = 'thread:users-mention-list-updated',
  // Notification events
  NOTIFICATION_NEW = 'notification:new',
  NOTIFICATION_READ = 'notification:read',
  NOTIFICATION_LIST = 'notification:list',
  NOTIFICATION_COUNT = 'notification:count',
  // Project events
  PROJECT_UPDATED = 'project:updated',
  // BRS task events
  BRS_TASK_UPDATED = 'brs-task:updated',
  // Budget request events
  BUDGET_REQUEST_UPDATED = 'budget-request:updated',
  // Deal events
  DEAL_UPDATED = 'deal:updated',
  // Deal events
  DEALS_GROUP_UPDATED = 'deals-group:updated',
  // HelpDesk task events
  HELPDESK_TASK_UPDATED = 'helpdesk-task:updated',
  // Iron Logic Control events (photo-verification report)
  EQUIPMENT_LOG_PHOTO_VERIFICATION_LIST = 'equipment-log-photo-verification:list',
  EQUIPMENT_LOG_PHOTO_VERIFICATION_UPDATED = 'equipment-log-photo-verification:updated',
  // "CCTV" module events
  CCTV_EVENT_REPORT_GET_REPORT = 'cctv-event-report:get-report',
  CCTV_EVENT_REPORT_NEW_EVENT = 'cctv-event-report:new-event',
}
